// import { useState } from "react";

// const ForgotPassword = () => {
//   const [email, setEmail] = useState("");

//   const handleSubmit = async () => {
//     const res = await fetch("/api/forgot-password", {
//       method: "POST",
//       headers: {
//         "content-type": "application/json"
//       },
//       body: JSON.stringify({ email })
//     });

//     const data = await res.json();
//     alert(data.message);
//   };

//   return (
//     <div className="flex justify-center items-center min-h-screen">
//       <div className="bg-white p-6 shadow rounded">
//         <h2>Forgot Password</h2>

//         <input
//           type="email"
//           placeholder="Enter email"
//           onChange={(e) => setEmail(e.target.value)}
//           className="border p-2 w-full"
//         />

//         <button
//           onClick={handleSubmit}
//           className="bg-black text-white w-full mt-3 p-2"
//         >
//           Send Reset Link
//         </button>
//       </div>
//     </div>
//   );
// };

// export default ForgotPassword;
import { useState } from "react";
import { motion } from "framer-motion";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!email) return alert("Please enter email");

    setLoading(true);

    const res = await fetch("/api/forgot-password", {
      method: "POST",
      headers: {
        "content-type": "application/json"
      },
      body: JSON.stringify({ email })
    });

    const data = await res.json();
    setLoading(false);

    alert(data.message);
  };

  return (
    <section className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-100 to-gray-200 px-4">

      {/* Card */}
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4 }}
        className="bg-white w-full max-w-md p-6 sm:p-8 rounded-2xl shadow-xl"
      >

        {/* Title */}
        <div className="text-center mb-6">
          <h2 className="text-2xl sm:text-3xl font-bold">
            Forgot Password 🔐
          </h2>

          <p className="text-gray-500 text-sm mt-2">
            Enter your email to receive a reset link
          </p>
        </div>

        {/* Input */}
        <div className="mb-4">
          <input
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full px-4 py-3 rounded-lg border bg-gray-100 outline-none focus:ring-2 focus:ring-black transition"
          />
        </div>

        {/* Button */}
        <button
          onClick={handleSubmit}
          disabled={loading}
          className="w-full bg-black text-white py-3 rounded-lg hover:opacity-90 transition flex items-center justify-center"
        >
          {loading ? "Sending..." : "Send Reset Link"}
        </button>

        {/* Back to login */}
        <p className="text-center text-sm text-gray-500 mt-5">
          Remember your password?{" "}
          <a href="/login" className="text-black font-medium hover:underline">
            Login
          </a>
        </p>

      </motion.div>

    </section>
  );
};

export default ForgotPassword;